export const isSSR = () => __SERVER__ ?? false;

export const getAggSubscriptionEndpoint = () =>
	`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
